import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";

export default function UrlPatternsAdmin() {
  const [custom, setCustom] = useState([]);
  const [defaults, setDefaults] = useState([]);
  const [form, setForm] = useState({ pattern: "", type: "Career Portal", label: "" });

  const load = useCallback(async () => {
    const { data } = await api.get("/url-patterns");
    setCustom(data.custom); setDefaults(data.defaults);
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/url-patterns", form);
      toast.success("Pattern added"); setForm({ pattern: "", type: "Career Portal", label: "" }); load();
    } catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); }
  };
  const remove = async (id) => {
    try { await api.delete(`/url-patterns/${id}`); load(); }
    catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); }
  };

  return (
    <div className="space-y-4" data-testid="url-patterns-admin">
      <form onSubmit={add} className="bg-slate-50 border border-slate-200 rounded-md p-3 grid grid-cols-1 md:grid-cols-4 gap-2">
        <input required placeholder="URL substring (e.g. myworkday)" value={form.pattern}
               onChange={(e) => setForm((f) => ({ ...f, pattern: e.target.value }))}
               data-testid="urlp-pattern"
               className="border border-slate-200 rounded-md px-3 py-2 text-sm" />
        <select value={form.type} onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
                className="border border-slate-200 rounded-md px-3 py-2 text-sm">
          <option>Career Portal</option><option>Easy Apply</option>
        </select>
        <input required placeholder="Label (e.g. Workday)" value={form.label}
               onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))}
               data-testid="urlp-label"
               className="border border-slate-200 rounded-md px-3 py-2 text-sm" />
        <button type="submit" data-testid="urlp-add"
                className="bg-sky-600 hover:bg-sky-700 text-white text-sm rounded-md px-4 py-2 flex items-center justify-center gap-2">
          <Plus size={16} /> Add
        </button>
      </form>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          <div className="p-4 border-b border-slate-100 font-semibold text-sm">Custom Patterns</div>
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 uppercase text-xs tracking-widest">
              <tr><th className="text-left px-4 py-2">Pattern</th><th>Type</th><th>Label</th><th></th></tr>
            </thead>
            <tbody>
              {custom.map((p) => (
                <tr key={p.id} className="border-t border-slate-100">
                  <td className="px-4 py-2 font-mono text-xs">{p.pattern}</td>
                  <td className="text-xs">{p.type}</td>
                  <td className="text-xs">{p.label}</td>
                  <td className="text-right px-4 py-2">
                    <button onClick={() => remove(p.id)} className="text-red-600 hover:text-red-800"><Trash size={14} /></button>
                  </td>
                </tr>
              ))}
              {custom.length === 0 && <tr><td colSpan={4} className="text-center text-slate-400 py-6">No custom patterns.</td></tr>}
            </tbody>
          </table>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          <div className="p-4 border-b border-slate-100 font-semibold text-sm">Built-in Patterns</div>
          <div className="max-h-[400px] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-500 uppercase text-xs tracking-widest sticky top-0">
                <tr><th className="text-left px-4 py-2">Pattern</th><th>Type</th><th>Label</th></tr>
              </thead>
              <tbody>
                {defaults.map((p) => (
                  <tr key={p.id} className="border-t border-slate-100">
                    <td className="px-4 py-2 font-mono text-xs">{p.pattern}</td>
                    <td className="text-xs">{p.type}</td>
                    <td className="text-xs">{p.label}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
